import { SolutionPage } from './SolutionPage'
import { solutionsData } from '@/data/solutions'

export default function Finance() {
  return <SolutionPage solution={solutionsData.finance!} />
}
